import { Entity, RELATION_DEPENDENCY_OF, stringifyEntityRef } from '@backstage/catalog-model';
import { readDependencyGrades, type DependencyGrade } from './dependencyCriticality';

/** Systems that declare a dependency on this entity, via the catalog's inverse relation. */
export function dependentSystemRefs(entity: Entity): string[] {
  const refs = (entity.relations ?? [])
    .filter(r => r.type === RELATION_DEPENDENCY_OF && r.targetRef.startsWith('system:'))
    .map(r => r.targetRef);
  return Array.from(new Set(refs)).sort();
}

/** The grade lives on the dependent, which is the side that declared the dependency. */
export function gradeFromDependent(
  dependent: Entity,
  target: Entity,
): DependencyGrade | undefined {
  return readDependencyGrades(dependent)[stringifyEntityRef(target)];
}
